import { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageHeader, Spinner, Card, EmptyState } from "@/components/dash";
import CoinIcon from "@/components/CoinIcon";
import { Button } from "@/components/ui/button";
import api, { apiErr } from "@/lib/api";
import { formatDate, truncate } from "@/lib/format";

const STATUS_TR = { pending: "Bekliyor", processing: "İşleniyor", completed: "Tamamlandı", failed: "Başarısız" };
const CLS = { pending: "bg-amber-500/10 text-amber-500", processing: "bg-primary/10 text-primary", completed: "bg-emerald-500/10 text-emerald-500", failed: "bg-red-500/10 text-red-500" };

export default function AdminCommissions() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/commissions").then(({ data }) => setItems(data.commissions)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const mark = async (c) => {
    try { await api.patch(`/admin/commissions/${c.id}`, { status: "completed", tx_hash: "0x" + Math.random().toString(16).slice(2, 18) }); toast.success("Komisyon tamamlandı."); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  if (!items) return <Spinner />;
  return (
    <div>
      <PageHeader title="Komisyonlar" desc="Başarılı işlemlerden alınan %1 platform komisyonları." />
      {items.length === 0 ? <EmptyState title="Komisyon kaydı yok" desc="Onaylanan ödemelerden komisyonlar burada oluşur." /> : (
        <Card className="overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead className="border-b border-border bg-muted/40"><tr className="text-left text-xs text-muted-foreground">
                {["Komisyon ID", "Payment ID", "Coin/Ağ", "Komisyon", "Hedef Cüzdan", "Hash", "Durum", "Tarih", "İşlem"].map((h) => <th key={h} className="px-4 py-3 font-medium whitespace-nowrap">{h}</th>)}
              </tr></thead>
              <tbody className="divide-y divide-border" data-testid="admin-commissions-table">
                {items.map((c) => (
                  <tr key={c.id} className="hover:bg-muted/30">
                    <td className="px-4 py-3 font-mono text-xs">{truncate(c.id, 6)}</td>
                    <td className="px-4 py-3 font-mono text-xs">{truncate(c.payment_id, 6)}</td>
                    <td className="px-4 py-3"><span className="inline-flex items-center gap-1.5"><CoinIcon symbol={c.coin} size={16} /> {c.coin}·{c.network}</span></td>
                    <td className="px-4 py-3 text-amber-500">{Number(c.amount).toFixed(6)}</td>
                    <td className="px-4 py-3 font-mono text-xs">{c.target_wallet ? truncate(c.target_wallet, 8) : <span className="text-red-500">Cüzdan yok</span>}</td>
                    <td className="px-4 py-3 font-mono text-xs">{truncate(c.tx_hash || "-", 6)}</td>
                    <td className="px-4 py-3"><span className={`text-xs px-2 py-0.5 rounded-full ${CLS[c.status]}`}>{STATUS_TR[c.status]}</span></td>
                    <td className="px-4 py-3 text-xs text-muted-foreground whitespace-nowrap">{formatDate(c.created_at)}</td>
                    <td className="px-4 py-3">{c.status !== "completed" && c.target_wallet && <Button size="sm" variant="outline" className="rounded-full" onClick={() => mark(c)}>Tamamla</Button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      )}
    </div>
  );
}
